export const USE_CASE_IDS = {
  LEAD_GENERATION: 'lead-generation',
  AUTOMATE_MARKETING: 'automate-marketing',
  BUILD_PIPELINE: 'build-pipeline',
  CLOSE_DEALS: 'close-deals',
  COLLECT_PAYMENTS_AND_SUBSCRIPTIONS: 'collect-payments-and-subscriptions',
  AUTOMATE_BILLING_AND_INVOICING: 'automate-billing-and-invoicing',
  SCALE_SUPPORT: 'scale-support',
  DRIVE_RETENTION: 'drive-retention'
};